import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-internal-grid',
  templateUrl: './internal-grid.component.html',
  styleUrls: ['./internal-grid.component.css']
})
export class InternalGridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/issues/internal/internal-grid/internal-grid.component.ts